module.exports = __webpack_public_path__ + "static/media/workingmemory-words-5.17bf082f.mp3";